import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import axios_api from '../Api';

import { API_URL, AUTH_TOKEN } from '../Context';


function Ticket({ticket}){
  console.log(ticket)
  return (

    ticket.viewed === true ?
      <>
        <p><Link to={`/ticket/` + ticket.id}>Обращение № {ticket.id}</Link></p>
      </>
    :
      <>
        <p><b><Link to={`/ticket/` + ticket.id}>Обращение № {ticket.id}</Link></b></p>
      </>
  )
}


export default function Tickets ({selectedYear}){
  const[tickets, setTickets] = useState([]);
  const navigate = useNavigate();
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {

    let labTypesNext = axios_api.get(api_url + '/user_tickets', {
      headers: {"Authorization": token},
      params: {"year": selectedYear}
    });

    labTypesNext.then(
      (result) => {
        //console.log(result);
        setTickets(result.data);
      },
      (error) => {
        console.log(error)
      }
    );

  }, []);

  let rows = [];
  for (let i in tickets) {
    rows.push(
      <Ticket 
        key={i} 
        ticket={tickets[i]}
      />
    ); 
  }

  return (
    <>
      <div className="row">
        <h3 className="m-3">Обращения</h3>
      </div>
      <button className='btn lk-button m-3' onClick={() => navigate('/ticket_create')}>Создать обращение</button>
      <div className="row m-3">
        {rows}
      </div>

    </>
  )
}